// extracted by mini-css-extract-plugin
module.exports = {"logo":"course-navbar_logo__32OIc","icon":"course-navbar_icon__1mMVv"};